document.addEventListener('DOMContentLoaded', async() => {
    initAnnouncement();
    initAppProducts()


    function waitForElements(selector, { timeout = 5000, settleTime = 300 } = {}) {
        return new Promise((resolve, reject) => {
          let settleTimeoutId;
      
          const observer = new MutationObserver(() => {
            const elements = document.querySelectorAll(selector);
      
            if (elements.length > 0) {
              // Every time we find elements, reset the settle timer.
              clearTimeout(settleTimeoutId);
      
              // If no new elements are found for the duration of `settleTime`,
              // assume all have loaded and resolve the promise.
              settleTimeoutId = setTimeout(() => {
                observer.disconnect();
                clearTimeout(mainTimeoutId); // Cancel the main timeout
                resolve(elements);
              }, settleTime);
            }
          });
      
          // Start observing the DOM for changes.
          observer.observe(document.body, {
            childList: true,
            subtree: true,
          });
      
          // A main timeout to ensure the promise doesn't hang forever.
          const mainTimeoutId = setTimeout(() => {
            observer.disconnect();
            const finalElements = document.querySelectorAll(selector);
            if (finalElements.length > 0) {
              // If we timed out but still found elements, resolve with what we have.
              resolve(finalElements);
            } else {
              reject(new Error(`Element "${selector}" nicht innerhalb von ${timeout}ms gefunden.`));
            }
          }, timeout);
          
          // Also check immediately in case the elements are already present.
          const initialElements = document.querySelectorAll(selector);
          if (initialElements.length > 0) {
              observer.disconnect();
              clearTimeout(mainTimeoutId);
              resolve(initialElements);
          }
        });
      }

    async function initAppProducts() {
        try {
            await waitForElements('.xsvai-item');
        } catch (error) {
            return;
        }
        const appWrappers = document.querySelectorAll('.xsvai-xsim-wrapper');

        appWrappers.forEach(wrapper => {
            const products = wrapper.querySelectorAll('.xsvai-item');
            const id = wrapper.getAttribute("id");
            const item_list = {
                id: id.includes("similar_products") ? "cross-selling-similar-products" : "cross-selling-complement-products",
                name: id.includes("similar_products") ? "Cross-Selling – Similar Products" : "Cross-Selling – Complement Products"
            }
            products.forEach((product, index) => {
                const aTag = product.querySelector('.xsvai-item__thumbnail');
                const variantId = aTag.href.split("variant=")[1];
                const title = product.querySelector('.xsvai-item__title').textContent;
                const price = product.querySelector('.xsvai-item__price span').textContent.replace("€", "").replace(",", ".").trim();
                const brand = product.querySelector('.xsvai-item__vendor').textContent;

                product.addEventListener('click', () => {
                    dataLayer.push({ ecommerce: null });
                    dataLayer.push({
                        event: "lt_select_item",
                            ecommerce: {
                                item_list_id: item_list.id,
                                item_list_name: item_list.name,
                                items: [
                                    {
                                    item_id: variantId,
                                    item_name: title,
                                    affiliation: brand,
                                    price: price,
                                    affiliation: "L&T",
                                    coupon: null,
                                    discount: 0,
                                    index: index + 1,
                                    item_brand: brand,
                                    item_list_id: item_list.id,
                                    item_list_name: item_list.name,
                                }
                            ]
                        }
                    });
                });
            });
        });
    }

    function initAnnouncement() {
        const announcement = document.querySelector('.announcement');
        if (announcement) {
            const links = announcement.querySelectorAll('.text-highlight__break a');    
            links.forEach(link => {
                link.addEventListener('click', () => {
                     const title = link.getAttribute('title');
                     const title_handle = title.toLowerCase().replace(/ /g, "-").replace(/[^a-z0-9-]/g, "");
                    dataLayer.push({
                        event: "lt_select_promotion",
                        ecommerce: {
                            promotions: [{
                            promotion_id: title_handle,
                            promotion_name: title,
                            creative_name: title,
                            creative_slot: "announcement_bar",
                            location_id: "site_top"
                            }]
                        }
                    });
                });
            });
        }
    }

});